import { File } from './../../models/files/files.model';
import { Category } from './../../models/categories/categories.model';
import { Form } from '../forms/forms.model';

export class Article {
    id?: string;
    title?: any;
    content?: any;
    parameters_title?: any;
    parameters_description?: any;
    parameters_remark?: any;
    custom_seo_data?: any;
    seo_title?: any;
    seo_description?: any;
    released?: Date;
    contained?: IContained;
    form?: Form;
    availableCategories?: Category[];

    constructor(options: any) {
        this.id = options.id;
        this.title = options.title;
        this.content = options.content;
        this.parameters_title = options.parameters_title;
        this.parameters_description = options.parameters_description;
        this.parameters_remark = options.parameters_remark;
        this.custom_seo_data = options.custom_seo_data;
        this.seo_title = options.seo_title;
        this.seo_description = options.seo_description;
        this.released = new Date(options.released);
        this.contained = options.contained;
        this.form = options.form;
        this.availableCategories = options.availableCategories;
    }
}

interface IContained {
    files?: Array<File>;
    categories?: Array<any>;
}
